<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2 v-if="$route.query.type == 'add'">新增优惠券</h2>
      <h2 v-if="$route.query.type == 'edit'">编辑优惠券</h2>
      <el-form
        :model="formData"
        ref="ruleForm"
        :rules="rules"
        label-width="130px"
      >
        <el-form-item label="优惠券名称" prop="name">
          <el-input
            style="width: 490px"
            v-model="formData.name"
            maxlength="20"
            show-word-limit
            placeholder="请输入优惠券名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="使用平台"
          prop="platformIds"
          style="margin-top: 20px"
        >
          <el-select
            style="width: 490px"
            v-model="formData.platformIds"
            placeholder="请选择平台"
            multiple
          >
            <el-option
              v-for="item in platformList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用商品" prop="type" style="margin-top: 20px">
          <el-radio v-model="formData.type" :label="1">全部商品</el-radio>
          <el-radio v-model="formData.type" :label="2">选择商品</el-radio>
        </el-form-item>
        <el-form-item label="" prop="" v-if="formData.type == '2'">
          <el-button type="primary" @click="selectGoods">选择商品</el-button>
          <div class="goods-box" v-if="allList.length > 0">
            <div
              style="width: 100%; display: flex; justify-content: space-between"
              v-for="(item, index) in allList"
              :key="item.id"
            >
              <div>
                <div class="goods-item">
                  <div class="number-dot">{{ index + 1 }}</div>
                  <p class="goods-title">{{ item.name }}</p>
                  <span class="del" @click="delFn(index)">删除</span>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="优惠券优惠金额"
          prop="price"
          style="margin-top: 20px"
        >
          <el-input
            style="width: 128px"
            v-model="formData.price"
            placeholder="请输入"
          ></el-input
          ><span style="margin-left: 12px">元</span>
        </el-form-item>
        <el-form-item
          label="最低满足金额"
          prop="minPrice"
          style="margin-top: 20px"
        >
          <el-input
            style="width: 128px"
            v-model="formData.minPrice"
            placeholder="请输入"
          ></el-input
          ><span style="margin-left: 12px">元</span>
        </el-form-item>
        <el-form-item label="起止时间" prop="dateArr" style="margin-top: 20px">
          <el-date-picker
            v-model="formData.dateArr"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="有效时间"
          prop="expireDate"
          style="margin-top: 20px"
        >
          <el-input
            style="width: 128px"
            v-model="formData.expireDate"
            placeholder="请输入"
          ></el-input
          ><span style="margin-left: 12px">天</span>
        </el-form-item>
        <el-form-item
          label="优惠券内容说明"
          prop="couponText"
          style="margin-top: 20px"
        >
          <el-input
            type="textarea"
            v-model="formData.couponText"
            maxlength="60"
            style="width: 466px"
            resize="none"
            placeholder="请输入说明"
            show-word-limit
            class="inputarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" style="margin-top: 20px">
          <el-radio v-model="formData.status" :label="1">启用</el-radio>
          <el-radio v-model="formData.status" :label="0">禁用</el-radio>
        </el-form-item>
      </el-form>
    </div>
    <div class="content bottom-but">
      <el-button type="warning" @click="toBack">返回</el-button>
      <el-button type="primary" @click="submitFn">确认</el-button>
      <div style="height: 20px"></div>
    </div>

    <el-dialog
      title="选择商品"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="815"
    >
      <div style="height: 600px; overflow-y: auto">
        <div class="search-box">
          <el-input
            placeholder="请输入商品名称/商品编号"
            size="mini"
            style="width: 224px; margin-right: 20px"
            v-model="goodsName"
          ></el-input>
          <el-button
            type="primary"
            @click="
              pageNo = 1;
              couponGoodsPageList();
            "
            size="mini"
            plain
            >查询</el-button
          >
        </div>
        <el-table
          :data="goodsList"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :show-header="false"
          border
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="goodsName" label="">
            <template slot-scope="scope">
              <div style="display: flex">
                <img
                  :src="scope.row.image"
                  style="width: 72px; height: 56px; margin-right: 12px"
                  alt=""
                />
                <div
                  style="
                    font-size: 14px;
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  "
                >
                  <p style="color: #333333">{{ scope.row.name }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.goodsNo }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 42px;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="pageNo"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { reactive } from 'vue'
import breadcrumbTop from '../../../components/breadcrumb.vue'
export default {
  components: {
    breadcrumbTop
  },
  data () {
    var validatePrice = (rule, value, callback) => {
      let reg = /^[0-9]+([.]{1}[0-9]{1,2})?$/
      if (value == '') {
        callback(new Error('请输入优惠金额'));
      } else {
        if (!reg.test(value)) {
          console.log(5555)
          callback(new Error('请输入正确优惠金额,最多保留两位小数'));
        } else {
          if (Number(value) > Number(this.formData.minPrice) && this.formData.minPrice != '') {
            callback(new Error('优惠金额不能大于最低金额'));
          } else {
            callback();
          }

        }

      }
    };
    var validateMinPrice = (rule, value, callback) => {
      let reg = /^[0-9]+([.]{1}[0-9]{1,2})?$/
      if (value == '') {
        callback(new Error('请输入最低满足金额'));
      } else {
        if (!reg.test(value)) {
          console.log(5555)
          callback(new Error('请输入最低满足金额,最多保留两位小数'));
        } else {
          if (Number(value) < Number(this.formData.price)) {
            callback(new Error('最低满足金额不能小于优惠金额'));
          } else {
            callback();
          }

        }

      }
    };
    return {
      platformList: [],
      goodsName: '',
      goodsList: [],
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '优惠券管理', path: '', type: '1' }
        ]
      },
      formData: {
        id: null,
        platformIds: [],
        name: '',
        type: null,
        price: '',
        minPrice: '',
        couponStartTime: '',
        couponEndTime: '',
        expireDate: '',
        couponText: '',
        status: null,
        goodsList: [],
        dateArr: [],
        // platformId: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        platformIds: [
          { required: true, message: '请选择平台', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择适用商品', trigger: 'change' }
        ],
        price: [
          { required: true, trigger: 'blur', validator: validatePrice, }
        ],
        minPrice: [
          { required: true, trigger: 'blur', validator: validateMinPrice, }
        ],
        dateArr: [
          { required: true, message: '请选择起止时间', trigger: 'change' }
        ],
        expireDate: [
          { required: true, message: '请输入有效时间', trigger: 'blur' }
        ],
        couponText: [
          { required: true, message: '请输入优惠券内容说明', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
      },
      dateArr: [],
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
      selectList: [],
      allList: []
    }
  },
  created () {
    // this.couponGoodsPageList()
    console.log(this.$route.query.id)
    this.formData.id = this.$route.query.id || null
    if (this.formData.id) {
      this.getDetail()
    }
    this.goodsPlatforms()
  },
  methods: {
    //获取平台列表
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        console.log(res)
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    selectGoods () {
      this.dialogVisible = true;
      this.couponGoodsPageList()
      this.$nextTick(() => {
        let list = []
        //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
        this.goodsList.forEach((item) => {
          this.allList.forEach(val => {
            if (val.id === item.id) {
              // 把判断出来的默认表格数据push到创建的数组中
              list.push(item)
            }
          })
        })
        // console.log(this.$refs.multipleTable)
        if (list) {
          //再遍历数组，将数据放入方法中
          list.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          })
        }
      })

    },
    getDetail () {
      this.axios.get('/ps/psCoupon/info?id=' + this.formData.id)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.formData = Object.assign(this.formData, res.data)
            this.formData.dateArr.push(res.data.couponStartTime.substring(0, 10))
            this.formData.dateArr.push(res.data.couponEndTime.substring(0, 10))
            if (res.data.goodsList && res.data.goodsList.length > 0) {
              this.allList = res.data.goodsList.map(item => {
                return {
                  id: item.goodsId,
                  name: item.goodsName
                }
              })
            }

            // console.log(this.formData.dateArr)
            // this.$forceUpdate()
          }
        })
    },
    delFn (idx) {
      this.allList.splice(idx, 1)
    },
    confirmFn () {
      this.allList = this.allList.concat(this.selectList)
      this.allList = this.removeDuplicateObj(this.allList)
      this.dialogVisible = false;
      console.log(this.allList)
    },
    //对象数组去重
    removeDuplicateObj (arr) {
      let newArr = []
      let obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].id]) {
          newArr.push(arr[i]);
          obj[arr[i].id] = true;
        }
      }
      return newArr
    },
    handleSelectionChange (e) {
      this.selectList = e;
    },
    toBack () {
      history.go(-1)
    },
    submitFn () {
      console.log('介绍', this.formData)
      if (this.formData.dateArr.length > 0) {
        this.formData.couponStartTime = this.formData.dateArr[0]
        this.formData.couponEndTime = this.formData.dateArr[1]
      } else {
        this.formData.couponStartTime = ''
        this.formData.couponEndTime = ''
      }
      if (this.formData.type == 2) {
        if (this.allList.length > 0) {
          let arr = this.allList.map(item => {
            return {
              goodsId: item.id,
              goodsName: item.name
            }
          })
          this.formData.goodsList = arr;
        } else {
          this.$message.warning('请选择商品')
          return
        }
      } else {
        this.formData.goodsList = []
      }

      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.axios.post('/ps/psCoupon/addEdit', this.formData)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('保存成功')
                history.go(-1)
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    handleCurrentChange (e) {
      this.pageNo = e;
      this.couponGoodsPageList()
    },
    handleSizeChange (e) {
      this.pageSize = e;
      this.pageNo = 1;
      this.couponGoodsPageList()
    },
    couponGoodsPageList () {
      let data = {
        name: this.goodsName,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        platformIds: this.formData.platformIds
      }
      this.axios.post('/goods/goods/couponGoodsPageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.goodsList = res.data.list;
            this.totalNum = res.data.totalNum;
          }
        })
    },
  }
}
</script>
<style scoped lang="scss">
.inputarea ::v-deep .el-textarea__inner {
  width: 466px;
  height: 96px;
}

.bottom-but {
  margin-top: -20px;
  //   text-align: center;

  .el-button {
    width: 220px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button + .el-button {
    margin-left: 32px;
  }
}

.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}

.goods-box {
  width: 504px;
  background: #f1f6ff;
  margin-top: 12px;
  padding: 20px;
  box-sizing: border-box;
}

.goods-item {
  display: flex;
  width: 100%;
  // justify-content: space-between;
  font-size: 16px;
  color: #333333;
  // margin-top: 15px;
  align-items: center;

  .number-dot {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #4168e7;
    margin-right: 12px;
    font-size: 12px;
    color: white;
    text-align: center;
    line-height: 18px;
  }

  .goods-title {
    width: 300px;
    margin-right: 30px;
  }

  .del {
    font-size: 14px;
    color: #f33f3f;
    cursor: pointer;
    margin-left: 38px;
  }
}
</style>